import { Component } from '@angular/core';

import { SnackbarConfiguration } from '../models';
import { SnackbarRef, SnackbarService } from '../services';

const SNACKBAR_PRIMARY: SnackbarConfiguration = {
  color: 'primary',
  message: 'This can contain a longer message with more feedback and guidance',
  primaryConfiguration: {
    icon: 'bat',
    subMessage: 'Please note that this message is a standard notification. '
      + 'It is not meant for error, warning or validation purposes. '
      + 'The icon as well as the issue presented should be contextualized.',
  },
};

const SNACKBAR_PRIMARY_WITH_NICE_ICON: SnackbarConfiguration = {
  color: 'primary',
  message: 'This can contain a longer message with more feedback and guidance',
  primaryConfiguration: {
    icon: {
      name: 'bat',
      font: 'regular',
    },
    subMessage: 'Please note that this message is a standard notification. '
      + 'It is not meant for error, warning or validation purposes. '
      + 'The icon as well as the issue presented should be contextualized.',
  },
  expiration: 10000,
};

const SNACKBAR_INFO: SnackbarConfiguration = {
  color: 'info',
  message: 'Good morning world!',
};

const SNACKBAR_INFO_WITH_ACTIONS: SnackbarConfiguration = {
  color: 'info',
  message: 'Good morning world!',
  actions: {
    right: {
      color: 'primary',
      icon: { name: 'hippo', font: 'regular' },
      text: 'Im beautiful',
      callback: () => console.warn('Yes you are !'),
    },
    left: {
      color: 'primary',
      icon: 'unicorn',
      text: 'am I beautiful?',
      callback: () => console.warn('Oh yes, you are !'),
    },
  },
  expiration: 15000,
};

const SNACKBAR_SUCCESS: SnackbarConfiguration = {
  color: 'success',
  message: 'All Good!',
};

const SNACKBAR_WARNING: SnackbarConfiguration = {
  color: 'warning',
  message: 'There was an issue while processing the data',
};

const SNACKBAR_WARNING_WITH_ACTION: SnackbarConfiguration = {
  color: 'warning',
  message: 'There was an issue while processing the data',
  actions: {
    left: {
      color: 'warning',
      icon: 'skull-crossbones',
      text: 'Poison',
      callback: () => console.warn('Hey, you should disappear'),
    },
  },
  expiration: 0,
};

const SNACKBAR_ERROR: SnackbarConfiguration = {
  color: 'error',
  message: 'The operation could not be completed... Please try again',
};

const SNACKBAR_ERROR_WITH_ACTION: SnackbarConfiguration = {
  color: 'error',
  message: 'The operation could not be completed... Please try again',
  actions: {
    right: {
      color: 'error',
      icon: 'times',
      text: '',
      callback: () => undefined, // Will be overridden on open
    },
  },
  afterClosedMessage: 'Im closed by the action !',
  expiration: null,
};

@Component({
  selector: 'app-snackbars',
  templateUrl: './snackbars.component.html',
  styleUrls: ['./snackbars.component.scss'],
  standalone: false,
})
export class SnackbarsComponent {
  public hasSnackbarInApp = false;
  private _currentSnackbar: SnackbarRef | undefined;

  constructor(private readonly _snackbarService: SnackbarService) {
    this.hasSnackbarInApp = !!document.querySelector('evi-mobile-snackbar');
  }

  public openPrimarySnackbar(): void {
    this.openSnackbar(SNACKBAR_PRIMARY);
  }

  public openPrimaryFancySnackbar(): void {
    this.openSnackbar(SNACKBAR_PRIMARY_WITH_NICE_ICON);
  }

  public openInfoSnackbar(): void {
    this.openSnackbar(SNACKBAR_INFO);
  }

  public openInfoFancySnackbar(): void {
    this.openSnackbar(SNACKBAR_INFO_WITH_ACTIONS);
  }

  public openSuccessSnackbar(): void {
    this.openSnackbar(SNACKBAR_SUCCESS);
  }

  public openWarningSnackbar(): void {
    this.openSnackbar(SNACKBAR_WARNING);
  }

  public openWarningFancySnackbar(): void {
    this.openSnackbar(SNACKBAR_WARNING_WITH_ACTION);
  }

  public openErrorSnackbar(): void {
    this.openSnackbar(SNACKBAR_ERROR);
  }

  public openErrorFancySnackbar(): void {
    this.openSnackbar({
      ...SNACKBAR_ERROR_WITH_ACTION,
      actions: {
        right: {
          ...SNACKBAR_ERROR_WITH_ACTION.actions?.right,
          callback: () => this._currentSnackbar?.close(SNACKBAR_ERROR_WITH_ACTION.afterClosedMessage, SNACKBAR_ERROR_WITH_ACTION.onAfterClosed),
        },
      },
    });
  }

  private openSnackbar(snackbar: SnackbarConfiguration): void {
    this._currentSnackbar?.close();
    this._currentSnackbar = this._snackbarService.open(snackbar);

    this._currentSnackbar
      .afterClosed()
      .subscribe((response: unknown) => {
        console.warn('something after closed:', response);
      });
  }
}
